import { Button } from '@frontend/design_system'
import { COMPLETE_CONFIRMATION, SUBMIT } from 'texts/common'
import { useState } from 'react'
import { Confirmation } from 'ui/molecules/Confirmation'
import { useApiRequest } from 'hooks/useApiRequest'
import { useCompanyId } from 'hooks/useCompanyId'
import { REGISTRATION_STATUSES } from 'api/auth/constants'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { setNotificationMessage } from 'redux/notifications/slice'
import { setPageStatus } from 'redux/login/slice'
import { formIsDirtySelector } from 'redux/forms/selectors'
import { SubmitButtonProps } from './types'
import styles from './styles.module.scss'

export const SubmitButton = ({ config }: SubmitButtonProps) => {
  const [isEditingModalOpen, setEditingModalOpen] = useState(false)
  const [isConfirmationModalOpen, setConfirmationModalOpen] = useState(false)
  const isDirty = useSelector(formIsDirtySelector(config.formId))
  const pendingCount = config.pendingCountSelector
    ? useSelector(config.pendingCountSelector)
    : 0

  const companyId = useCompanyId()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const completeRequest = useApiRequest(config.completeApiRequest)

  const handleModalShow = () => {
    if (isDirty) {
      setEditingModalOpen(true)
    } else {
      setConfirmationModalOpen(true)
    }
  }

  const handleEditingModalClose = () => {
    setEditingModalOpen(false)
  }

  const handleModalClose = () => {
    setConfirmationModalOpen(false)
  }

  const handleCompleteConfirm = async () => {
    if (companyId) {
      const response = await completeRequest.apiRequest(companyId)
      if (response) {
        handleModalClose()
        handleEditingModalClose()
        dispatch(
          setNotificationMessage({
            notificationMessage: config.successMessage,
          })
        )
        dispatch(
          setPageStatus({
            [config.pageStatusKey]: REGISTRATION_STATUSES.REVIEW,
          })
        )
        if (config.navigateUrl) {
          navigate(config.navigateUrl)
        }
      }
    }
  }

  return (
    <>
      {isEditingModalOpen && (
        <Confirmation
          confirmModalProps={{
            question: COMPLETE_CONFIRMATION[config.textKey].QUESTION,
            onConfirm: handleCompleteConfirm,
            onClose: handleEditingModalClose,
            title: COMPLETE_CONFIRMATION[config.textKey].TITLE,
            confirmLabel: COMPLETE_CONFIRMATION[config.textKey].BUTTON_LABEL,
            declineLabel: COMPLETE_CONFIRMATION[config.textKey].CANCEL_LABEL,
          }}
        />
      )}
      {isConfirmationModalOpen && (
        <Confirmation
          confirmModalProps={{
            question: COMPLETE_CONFIRMATION.CONFIRMATION_MODAL.QUESTION,
            onConfirm: handleCompleteConfirm,
            onClose: handleModalClose,
            title: COMPLETE_CONFIRMATION.CONFIRMATION_MODAL.TITLE,
            confirmLabel: COMPLETE_CONFIRMATION.CONFIRMATION_MODAL.BUTTON_LABEL,
          }}
        />
      )}
      <div className={styles['complete-btn']}>
        <Button
          onClick={handleModalShow}
          label={SUBMIT}
          disabled={!(config.withoutDisabled || pendingCount)}
          variant="green"
        />
      </div>
    </>
  )
}
